import angular from 'angular';
const componentOptions = {
    bindings: {
        giftCardName: '=',
        show: '<',
        containerForm: '='

    },
    controllerAs : 'giftCardsCardNameCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-card-name-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsCardName',
    inject:['GiftCardsAppConstants'],
    required: []
};
export class ibGiftCardsCardName implements angular.IController {

    constructor (private GiftCardsAppConstants: GiftCardsAppConstant) {
    }

}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsCardName.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsCardName })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsCardName.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsCardName })
    );
}
